import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MasterService } from 'src/app/services/master.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import {
  faShieldHalved,
  faPen,
  faEnvelope,
  faPhone,
  faShield,
  faBoxArchive,
  faUser,
  faLayerGroup
} from '@fortawesome/free-solid-svg-icons';

import { Main_menu_item } from 'src/app/interfaces/main-menu-item';

interface MenuNode {
  ID: number;
  ShortTitle: string;
  Parent: number;
  Default: boolean;
  Type: string;
  NamePage: string;
  Order: number;
  iconName?: string;
  route?: string;
  children?: MenuNode[];
  isEditing?: boolean;
  isNew?: boolean;
}

interface FlatNode {
  expandable: boolean;
  ID: number;
  ShortTitle: string;
  Parent: number;
  Default: boolean;
  Type: string;
  NamePage: string;
  Order: number;
  iconName?: string;
  level: number;
  isEditing?: boolean;
  isNew?: boolean;
}

@Component({
  selector: 'menu-settings',
  templateUrl: './menu-settings.component.html',
  styleUrls: ['./menu-settings.component.css']
})
export class MenuSettings implements OnInit {
  public faMenu = faUser;
  public faLayerGroup = faLayerGroup;
  public faShieldHalved = faShieldHalved;
  public faPen = faPen;
  public faEnvelope = faEnvelope;
  public faPhone = faPhone;
  public faShield = faShield;
  public faBoxArchive = faBoxArchive;
  public flEdit = 0;
  public struct_data: any;
  @Input() ID: number = 0;
  
  treeControl: FlatTreeControl<FlatNode>;
  treeFlattener: MatTreeFlattener<MenuNode, FlatNode>;
  treeDataSource: MatTreeFlatDataSource<MenuNode, FlatNode>;
  viewMode: 'table' | 'tree' = 'tree';
  
  displayedColumns: string[] = ['ID', 'ShortTitle', 'Parent', 'Default', 'Type', 'NamePage', 'Order', 'Actions'];
  dataSourceModules: any;
  menu_items_data: any;
  selected_menu_item: any;
  show_archieved: boolean = false;
  private originalData: any = {};
  private originalNodeBackup: any;
  private expandedNodesBeforeEdit: Set<number> = new Set();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private service: MasterService,
    private _snackBar: MatSnackBar,
    private storageService: AuthenticationService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.treeControl = new FlatTreeControl<FlatNode>(
      node => node.level,
      node => node.expandable
    );

    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      node => node.level,
      node => node.expandable,
      node => node.children
    );

    this.treeDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  ngOnInit(): void {
    this.GetModulesMenuTable();
  }

  transformer = (node: MenuNode, level: number): FlatNode => {
    return {
      expandable: !!node.children && node.children.length > 0,
      ID: node.ID,
      ShortTitle: node.ShortTitle,
      Parent: node.Parent,
      Default: node.Default,
      Type: node.Type,
      NamePage: node.NamePage,
      Order: node.Order,
      iconName: node.iconName,
      level: level,
      isEditing: node.isEditing || false
    };
  }

  buildTree(items: any[]): MenuNode[] {
    const itemMap = new Map();
    const tree: MenuNode[] = [];

    items.forEach(item => {
      const id = Number(item.ID);
      const parent = Number(item.Parent);
      
      itemMap.set(id, { 
        ...item, 
        ID: id,
        Parent: parent,
        children: [], 
        isEditing: item.isEditing || false 
      });
    });

    items.forEach(item => {
      const id = Number(item.ID);
      const parent = Number(item.Parent);
      const node = itemMap.get(id);
      
      if (parent && parent !== 0 && itemMap.has(parent)) {
        const parentNode = itemMap.get(parent);
        if (parentNode) {
          parentNode.children = parentNode.children || [];
          parentNode.children.push(node);
        }
      } else {
        tree.push(node);
      }
    });

    const sortTree = (nodes: MenuNode[]) => {
      nodes.sort((a, b) => (a.Order || 0) - (b.Order || 0));
      nodes.forEach(node => {
        if (node.children && node.children.length) {
          sortTree(node.children);
        }
      });
    };
    sortTree(tree);

    return tree;
  }

  private saveExpandedState() {
    this.expandedNodesBeforeEdit.clear();
    if (this.treeControl.dataNodes) {
      this.treeControl.dataNodes.forEach(node => {
        if (this.treeControl.isExpanded(node)) {
          this.expandedNodesBeforeEdit.add(node.ID);
        }
      });
    }
  }

  private restoreExpandedState() {
    if (this.treeControl.dataNodes) {
      this.treeControl.dataNodes.forEach(node => {
        if (this.expandedNodesBeforeEdit.has(node.ID)) {
          this.treeControl.expand(node);
        }
      });
    }
  }

  loadTreeData() {
    if (this.menu_items_data) {
      this.saveExpandedState();
      
      const treeData = this.buildTree(this.menu_items_data);
      this.treeDataSource.data = treeData;
      this.cdr.detectChanges();

      setTimeout(() => {
        this.restoreExpandedState();
        this.cdr.detectChanges();
      }, 50);
    }
  }

  startTreeEdit(node: FlatNode) {
    console.log('startTreeEdit called', node);
    const nodeId = Number(node.ID);
    
    const originalNode = this.menu_items_data.find((item: any) => Number(item.ID) === nodeId);
    
    if (originalNode) {
      console.log('Original node found', originalNode);
      this.originalNodeBackup = JSON.parse(JSON.stringify(originalNode));
      originalNode.isEditing = true;
      this.loadTreeData();
      this.cdr.detectChanges();
    } else {
      console.log('Original node NOT found', nodeId);
    }
  }

  saveTreeEdit(node: FlatNode) {
    const nodeId = Number(node.ID);
    const originalNode = this.menu_items_data.find((item: any) => Number(item.ID) === nodeId);
    
    if (originalNode) {
      if (originalNode.Default) {
        this.menu_items_data.forEach((item: any) => {
          if (Number(item.ID) !== originalNode.ID) {
            item.Default = false;
          }
        });
      }
      
      originalNode.isEditing = false;
      if(originalNode.Parent==0) {
        originalNode.Parent=null;
      }
      if(originalNode.isNew==true){
         this.service.Add_menu_item(originalNode).subscribe(
        (result: any) => {
          this.openSnackBar('Запись успешно добавлена', 'OK');
          this.refresh();
        },
        (error) => {
          this.openSnackBar('Ошибка при добавлении записи', 'OK');
          console.error('Error adding menu item:', error);
        }
      );
      originalNode.isNew=false;
      }
      else{
        this.Update_menu_item(originalNode);
      }
      this.originalNodeBackup = null;
      this.loadTreeData();
      this.cdr.detectChanges();
    }
  }

  cancelTreeEdit(node: FlatNode) {
    
    const nodeId = Number(node.ID);
    const index = this.menu_items_data.findIndex((item: any) => Number(item.ID) === nodeId);
    
    if (index !== -1 && this.originalNodeBackup) {
      this.menu_items_data[index] = this.originalNodeBackup;
      this.menu_items_data[index].isEditing = false;
      this.originalNodeBackup = null;
      this.loadTreeData();
      this.cdr.detectChanges();
    }
    else if(index !== -1 &&!this.originalNodeBackup){
      this.menu_items_data.splice(index,1);
      this.originalNodeBackup = null;
      this.loadTreeData();
      this.cdr.detectChanges();
    }
  }

  addTreeChild(node: FlatNode) {
    const nodeId = Number(node.ID);
    const parentNode = this.menu_items_data.find((item: any) => Number(item.ID) === nodeId);
    
    if (parentNode) {
      const newId = Math.max(...this.menu_items_data.map((m: any) => Number(m.ID)), 0) + 1;
      const existingChildren = this.menu_items_data.filter((item: any) => Number(item.Parent) === nodeId);
    
    const maxOrder = existingChildren.length > 0 
      ? Math.max(...existingChildren.map((child: any) => Number(child.Order)))
      : 0;
      const newChild: any = {
        ID: newId,
        ShortTitle: 'Новый пункт',
        Parent: parentNode.ID,
        Default: false,
        Type: 'Menu',
        NamePage: '',
        Order: maxOrder + 1,
        isEditing: true,
        isNew: true
      };

      this.menu_items_data.push(newChild);
      this.saveExpandedState();
      this.loadTreeData();
      this.restoreExpandedState();
      this.cdr.detectChanges();
    }
  }

  private findNodeInTree(tree: MenuNode[], id: number): MenuNode | null {
    for (const node of tree) {
      const nodeId = Number(node.ID);
      if (nodeId === id) return node;
      if (node.children) {
        const found = this.findNodeInTree(node.children, id);
        if (found) return found;
      }
    }
    return null;
  }

  filterTree(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.loadTreeData();
      return;
    }

    const filterTreeRecursive = (nodes: MenuNode[]): MenuNode[] => {
      return nodes.filter(node => {
        const matches = node.ShortTitle.toLowerCase().includes(filterValue);
        if (node.children) {
          node.children = filterTreeRecursive(node.children);
        }
        return matches || (node.children && node.children.length > 0);
      });
    };

    const filteredTree = filterTreeRecursive(this.buildTree(this.menu_items_data));
    this.treeDataSource.data = filteredTree;
    this.treeControl.expandAll();
    this.cdr.detectChanges();
  }

  expandAll() {
    this.treeControl.expandAll();
    this.cdr.detectChanges();
  }

  collapseAll() {
    this.treeControl.collapseAll();
    this.cdr.detectChanges();
  }

  getTotalItemsCount(): number {
    const countNodes = (nodes: MenuNode[]): number => {
      let count = nodes.length;
      nodes.forEach(node => {
        if (node.children) count += countNodes(node.children);
      });
      return count;
    };
    return this.treeDataSource.data ? countNodes(this.treeDataSource.data) : 0;
  }

  addNewRow() {
    const newRow: any = {
      ID: 0,
      ShortTitle: '',
      Parent: 0,
      Default: false,
      Type: '',
      NamePage: '',
      Order: this.menu_items_data ? this.menu_items_data.length + 1 : 1,
      isEditing: true,
      isNew: true
    };

    this.menu_items_data.unshift(newRow);
    this.loadTreeData();
    this.cdr.detectChanges();
  }

  startEdit(element: any) {
    this.originalData[element.ID] = { ...element };
    element.isEditing = true;
    this.cdr.detectChanges();
  }

  

  cancelEdit(element: any) {
    if (element.isNew) {
      const index = this.menu_items_data.indexOf(element);
      if (index > -1) {
        this.menu_items_data.splice(index, 1);
        this.loadTreeData();
      }
    } else {
      if (this.originalData[element.ID]) {
        Object.assign(element, this.originalData[element.ID]);
        delete this.originalData[element.ID];
      }
      element.isEditing = false;
    }
    this.cdr.detectChanges();
  }

  

  Add_menu_item() {
    const newId = Math.max(...this.menu_items_data.map((m: any) => Number(m.ID)), 0) + 1;
    
    const existing = this.menu_items_data.filter((item: any) => Number(item.Parent) === 0);
    
    const maxOrder = existing.length > 0 
      ? Math.max(...existing.map((child: any) => Number(child.Order)))
      : 0;
      const newChild: any = {
        ID: newId,
        ShortTitle: 'Новый пункт',
        Parent: 0,
        Default: false,
        Type: 'Menu',
        NamePage: '',
        Order: maxOrder + 1,
        isEditing: true,
        isNew: true
      };

      this.menu_items_data.push(newChild);
      this.saveExpandedState();
      this.loadTreeData();
      this.restoreExpandedState();
      this.cdr.detectChanges();
    
  
  }

  onDefaultChange(node: any) {
    if (node.Default) {
      this.menu_items_data.forEach((item: any) => {
        if (Number(item.ID) !== Number(node.ID)) {
          item.Default = false;
        }
      });
    }
    this.Update_menu_item(node);
    this.cdr.detectChanges();
  }

  Update_menu_item(menu_item: Main_menu_item) {
    if(menu_item.Parent==0) menu_item.Parent=null;
    this.service.Update_menu_item(menu_item).subscribe((result: any) => {
      this.refresh();
    });
  }

  Delete_menu_item(menu_item: Main_menu_item) {
    this.service.Delete_menu_item(menu_item).subscribe((result: any) => {
      this.refresh();
    });
  }

  

  GetModulesMenuTable() {
    this.service.Get_menu_items().subscribe((result: any) => {
      if (result.data != null) {
        this.storageService.saveToken(result.jwt);
        this.menu_items_data = result.data.map((item: any) => ({
          ...item,
          ID: Number(item.ID),
          Parent: Number(item.Parent),
          Order: Number(item.Order),
          isEditing: false
        }));

        this.loadTreeData();
        this.cdr.detectChanges();
      } else {
        this.router.navigate(['login']);
      }
    });
  }

  Filterchange(event: Event) {
    const filvalue = (event.target as HTMLInputElement).value;
    this.dataSourceModules.filter = filvalue;
    this.cdr.detectChanges();
  }

  getrow(row: any) {
    this.selected_menu_item = row;
  }

  public refresh() {
    this.GetModulesMenuTable();
  }

  public ChangeArchivated(menu_item: Main_menu_item) {
    console.log('change archivated');
    this.service.Update_menu_item(menu_item).subscribe((result: any) => {
      this.refresh();
    });
  }
updateNodeValue(node: FlatNode, field: string, value: any) {
  const nodeId = Number(node.ID);
  const originalNode = this.menu_items_data.find((item: any) => Number(item.ID) === nodeId);
  if (originalNode) {
    originalNode[field] = value;
    console.log(`Updated ${field} to ${value} for node ${nodeId}`);
  }
}
  ngOnChanges() {
    this.GetModulesMenuTable();
  }
}